import React, { type CSSProperties } from 'react'
import { type FormatDateOptions, useIntl } from 'react-intl'
import AspectContainer from '../../../../../../components/AspectContainer/AspectContainer'

import { useWebinarColors } from '../../../../../../hooks/useWebinarColors'
import { WebinarPanelComponent } from '../../../index'

import LiveNow from './LiveNow'

import './SessionCard.scss'

const FORMAT_DATE_OPTIONS: FormatDateOptions = {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
}

const FORMAT_TIME_OPTIONS: FormatDateOptions = {
  hour12: false,
  hour: '2-digit',
  minute: '2-digit',
}

interface SessionCardProp {
  title: string
  thumbnailUrl: string
  linkUrl: string
  startDate: Date
  buttonText: string
  endDate?: Date
  names?: Array<string>
  isLive?: boolean
}

// eslint-disable-next-line react/display-name
export default ({
  title,
  thumbnailUrl,
  linkUrl,
  startDate,
  buttonText,
  endDate,
  names = [],
  isLive = false,
}: SessionCardProp) => {
  const intl = useIntl()
  const webinarColors = useWebinarColors()

  const date = intl.formatDate(startDate, FORMAT_DATE_OPTIONS)

  const timeRange = endDate
    ? intl.formatDateTimeRange(startDate, endDate, FORMAT_TIME_OPTIONS)
    : intl.formatDate(endDate, FORMAT_TIME_OPTIONS)

  return (
    <WebinarPanelComponent className="session-card">
      <div className="content-enclosure">
        <div className="header">{title}</div>
        <div className="labels-thumbnail-enclosure">
          <div className="labels">
            <div className="date">
              {isLive ? <LiveNow /> : `${date} ${timeRange}`}
            </div>
            <div className="speakers">{names.join(' · ')}</div>
          </div>
          <div className="thumbnail">
            <AspectContainer>
              <img src={thumbnailUrl} alt="thumbnail" />
            </AspectContainer>
          </div>
        </div>
      </div>
      <div className="footer">
        <a
          href={linkUrl}
          className={
            isLive ? 'primary-session-button' : 'secondary-session-button'
          }
          style={
            {
              '--secondary-background':
                webinarColors.tabs.contrast.transparent('50%'),
              '--secondary-text': webinarColors.tabs.contrast.contrast.color,
            } as CSSProperties
          }
        >
          {buttonText}
        </a>
      </div>
    </WebinarPanelComponent>
  )
}
